<template>
    <div class="pageWrap">
            <!-- <el-image 
                style="width: 300px; height: 300px"
                :src="params.url" 
                :preview-src-list="[params.url]">
            </el-image> -->
            <!-- <vue-qr :text="src" :size="200"></vue-qr> -->
            <div class="payQrCodeWrap">
                <!-- <div style="height: 100%;">
                    <img style="width: 100%;" :src="qrCodeImg" alt="暂无图片" />
                </div> -->
                <canvas  id="canvas"></canvas>
            </div>
    </div>
</template>

<script>
    // import VueQr from 'vue-qr'
  import qrCodeImg from '@/assets/images/qrcodeImg.jpg';
    export default {
        components: {
        },
        props:{
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
        },
        computed: {
            tableDataCom() {
            }
        },
        data() {
            return {
                dataUrl: null,
                qrCodeImg:qrCodeImg,
            }
        },
        created () {
            console.log("ddddddddd",this.params)
        },
        mounted () {
            this.getQrCode();
        },
        methods: {
            getQrCode(){
                let that = this;
                let QRCode = require('qrcode')
                let canvas = document.getElementById('canvas')
                let qrCodeUrl = that.params.paramsData ? that.params.paramsData.url : "";
                QRCode.toCanvas(canvas, qrCodeUrl, function (error) {
                    if (error) console.error(error)
                    console.log('success!');
                })
                //在二维码中间添加logo
            }
        },
    }
</script>

<style lang="scss" scoped>
.marB20{margin-bottom: 20px;}
    #canvas{
        width: 300px !important;
        height: 300px !important;
        border-radius: 20px;
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
    }
    .payQrCodeWrap{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 300px;
        height: 400px;
        position: relative;
        .text{
            margin-bottom: 20px;
            color: #fff;
            font-size: 22px;
            font-weight: bold;
        }
    }
    .pageWrap{
        display: flex;
        align-items: center;
        justify-content: center;
        .labelColor{
            color: #686868;
        }
        .valueColor{
            color: #000000;
        }
        .marB10{margin-bottom: 10px;}
        .marB5{margin-bottom: 5px;}
        .title{
            font-size: 20px;
            margin-bottom: 20px;
        }
        .itemMerWrap{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .itemDiv{
                width: 25%;
                margin: 10px 0px;
            }
        }
        .itemAddMerWrap{
            .addCItem{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
             border-bottom: 1px solid #e6e6e6;
                .itemDiv{
                    width: 25%;
                    margin: 10px 0px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/layout/components/qrCode.vue